import { COOKIE_EXPIRATION_DAYS_SMS_CONSENT, SMS_CONSENT_COOKIE } from '@hts/entities/Card/consts';
import styles from '@hts/entities/Card/styles/InfoContent/Buy/SMSConsent.module.scss';
import colors from '@hts/shared/styles/Colors.module.scss';
import { HtsTypography } from '@hts/shared/ui';
import Cookies from 'js-cookie';
import { memo, useCallback } from 'react';
import { PhoneInput } from 'react-international-phone';

import 'react-international-phone/style.css';

import '@hts/entities/Card/styles/InfoContent/Buy/PhoneInput.scss';
import '@hts/entities/Card/styles/InfoContent/CardBuyBlock.scss';

interface ISMSConsentProps {
  smsConsent: boolean;
  phoneNumber: string;
  phoneError: boolean;
  handleSmsConsent: (value: boolean) => void;
  handlePhoneChange: (value: string) => void;
}

export const SMSConsent: React.FC<ISMSConsentProps> = memo(
  ({ smsConsent, phoneNumber, phoneError, handleSmsConsent, handlePhoneChange }) => {
    const handleSmsConsentChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.checked;

        handleSmsConsent(newValue);

        Cookies.set(SMS_CONSENT_COOKIE, String(newValue), {
          expires: COOKIE_EXPIRATION_DAYS_SMS_CONSENT,
        });
      },
      [handleSmsConsent]
    );

    return (
      <div className={styles.smsConsent}>
        <HtsTypography
          variant="subtitle"
          element="span"
          color="gray2"
          className={styles.smsConsentTitle}
        >
          Receive your card via Text Message too:
        </HtsTypography>

        <div className={styles.phoneInputContainer}>
          <PhoneInput
            style={{ borderColor: phoneError ? 'red' : colors.primaryDark }}
            hideDropdown
            defaultCountry="us"
            autoFocus={false}
            value={phoneNumber}
            onChange={handlePhoneChange}
          />
        </div>

        <label className={styles.smsConsentLabel}>
          <input
            type="checkbox"
            checked={smsConsent}
            required={smsConsent}
            onChange={handleSmsConsentChange}
          />

          <HtsTypography variant="subtitle" element="span" color="gray2">
            I agree to receive SMS messages from ihopetoseeyou.com about my order, including a
            digital copy of my card. Message & data rates may apply. Reply STOP to unsubscribe.
          </HtsTypography>
        </label>
      </div>
    );
  }
);
